module.exports = __webpack_public_path__ + "lp/img/zoom_out_light.2f1a3448.svg";